import moment from 'moment';
import { getReservationInvoicesForHost } from 'utils/apis/reservationInvoiceRunningNumber';

/**
 * Map one API invoice line to table / modal row shape.
 * @param {{ reservation?: object, invoiceNumber?: string }} entry
 */
const mapInvoiceEntry = entry => {
  const res = entry.reservation || {};
  const _id = res._id != null ? String(res._id) : `invoice-${String(entry.invoiceNumber || 'unknown')}`;
  const createdAt = res.createdAt;

  return {
    _id,
    createdAt,
    invoiceNo: entry.invoiceNumber || '',
    bookingNo: res.code || '',
    reservation: res
  };
};

/**
 * @param {string} hostId
 * @param {number[]} years - distinct calendar years to fetch (merged, deduped by reservation id)
 */
const fetchInvoicesForYears = async (hostId, years) => {
  const uniqueYears = [...new Set(years.filter(y => y != null && !Number.isNaN(y)))];
  if (uniqueYears.length === 0) {
    return [];
  }

  const payloads = await Promise.all(uniqueYears.map(year => getReservationInvoicesForHost(hostId, { year })));

  const byId = new Map();
  for (const payload of payloads) {
    const rows = (payload && payload.invoices) || [];
    for (const entry of rows) {
      const mapped = mapInvoiceEntry(entry);
      byId.set(String(mapped._id), mapped);
    }
  }

  return Array.from(byId.values());
};

/**
 * @param {Object} params
 * @param {string} params.hostId
 * @param {number[]} params.years - years covered by the date filter (e.g. start and end year)
 */
export const getInvoiceList = async ({ hostId, years } = {}) => {
  if (!hostId) {
    return [];
  }
  return fetchInvoicesForYears(hostId, years);
};

/**
 * Resolve a row for the PDF modal from an in-memory list (no single-invoice GET in API).
 * @param {string} invoiceId
 * @param {Array} list
 */
export const getInvoiceById = (invoiceId, list = []) => {
  const row = list.find(item => String(item._id) === String(invoiceId));
  return Promise.resolve(row ? { ...row } : {});
};
